var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTopSmallNews = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 863 75",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M91 75H0V62H91V75ZM430 75H429V0H430V75ZM541 75H450V62H541V75ZM133 54H0V40H133V54ZM583 54H450V40H583V54ZM413 34H0V20H413V34ZM863 34H450V20H863V34ZM54 12H0V0H54V12ZM504 12H450V0H504V12Z",
  fill: "#DFDFDF"
})));
export default SvgTopSmallNews;